import { Component, ErrorHandler, Injector, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { SiriusBaseComponent } from 'sirius-framework';
import { AppInjector } from './app.injector';
import { TimeoutPopupService } from './popup/idleTimeOut/idletimeout.service';
import { CommonService } from './shared/service/shared.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends SiriusBaseComponent<any> {
  @ViewChild("template") template: TemplateRef<any>;

  modalRef: BsModalRef;


  isHeightLong: boolean = true;
  isShadowAndBg: boolean = true;

  documentOpen: boolean = false;
  docType: string = "0";

  subscriptionLoggedId: Subscription;
  isLoggedIn: boolean = false;
  hasTimeOut: boolean = false;
  counter: number = 300;
  @ViewChild('idleTimeOut') timerComponent;
  logOutTimeRunOut: boolean = false;
  protected routerService: Router;
  constructor(private router: Router,
    private commonService: CommonService,
    private timeOutPopupService: TimeoutPopupService,
    private modalService: BsModalService  ) {
    super();

    const injector = AppInjector.getInjector();
    this.routerService = injector.get(Router);

    if (this.commonService.sessionService == undefined) {
      this.commonService.sessionService = this.sessionService;
    }

    router.events.subscribe(e => {

      this.commonService.urlService();

      if (e instanceof NavigationEnd) {
        if (e.urlAfterRedirects == '/landing') {
          this.isHeightLong = true;
          this.isShadowAndBg = true;
        }
        else {
          this.isHeightLong = false;
          if (e.urlAfterRedirects.includes('/inner-menu')) {
            this.isShadowAndBg = false;
          }
          else {
            this.isShadowAndBg = true;
          }
        }
      }
    });
  }

  OnInit() {
    this.subscriptionLoggedId = this.commonService.loggedUserName.subscribe(state => {
      this.isLoggedIn = (state != '');
      if (this.isLoggedIn) {
        this.setIdleTimeOutPopUp();
      }
      else {
        this.commonService.sessionService.stopIdleTimeout();
      }
    });

  }
  displayStyle = "none";

  openPopup() {
    this.displayStyle = "block";
  }
  closePopup() {
    this.displayStyle = "none";
  }

  ngOnDestroy() {
    this.subscriptionLoggedId.unsubscribe();
  }

  setIdleTimeOutPopUp() {
    this.timeOutPopupService.add(this.timerComponent);
    this.registerTimeOutPopup();
  }
  // login olunmadığı sürece diğer ekranlarda popup çıkmaz
  // çıkması için auth. true ve forc. false yap. 
  registerTimeOutPopup() {
    this.commonService.sessionService.registerIdleTimeout(this.counter, (count) => {
      if (this.commonService.sessionService.authenticated) {
        if (count > this.counter) {
          this.commonService.logOut(false);
        } else {
          this.timerComponent.startCounter();
          this.showIdleTimeOutPopup();
          this.timeOutPopupService.showPopup();
        }
      }
    });
  }

  clickContinue() {
    this.timerComponent.stopCounter();
    this.timerComponent.counter = this.counter;
    this.commonService.sessionService.resetIdleTimeout();
    this.closeIdleTimeOut();
  }

  resetIdleTimeOut() {
    this.commonService.sessionService.resetIdleTimeout();
  };

  showIdleTimeOutPopup() {
    this.hasTimeOut = true;
  }

  closeIdleTimeOut() {
    this.hasTimeOut = false;
  }

  logOutWithoutRedirect(e: any) {
    this.commonService.sessionService.authenticated = false;
    this.commonService.sessionService.forceTimeout = true;
  }

  okErrorPopup(event: any) {
    this.commonService.sessionService.resetIdleTimeout();
    this.closeIdleTimeOut();
    this.commonService.logOut(false);
  }

  closeDocument(title: any) {
    this.documentOpen = false;
  }
  cancelDocument(title: any) {
    this.documentOpen = false;
  }
}
